import { ReactNode } from 'react';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { MobileTabBar } from './MobileTabBar';
import { NetworkStatusBanner } from '../NetworkStatusBanner';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="iw-app density-inspector">
      {/* Banner renders above TopBar in normal flow so it doesn't overlay
          sticky-header controls (Retry chip, etc). Self-hides when online. */}
      <NetworkStatusBanner />
      <TopBar />
      <div className="iw-body">
        <Sidebar />
        <main className="iw-main" id="main-content">
          {children}
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
}
